import React, { useState } from 'react';

const FilterwithImage = () => {
  const [filter, setFilter] = useState('');

  const handleFilterChange = (event) => {
    setFilter(event.target.value.toLowerCase());
  };

  const filterItems = (items) => {
    return items.filter((item) => item.text.toLowerCase().includes(filter));
  };

  const originalItems = [
    { id: 1, text: 'Apple', imageUrl: 'apple.jpg' },
    { id: 2, text: 'Banana', imageUrl: 'banana.jpg' },
    { id: 3, text: 'Cherry', imageUrl: 'cherry.jpg' },
    { id: 4, text: 'Date', imageUrl: 'date.jpg' },
    { id: 5, text: 'Elderberry', imageUrl: 'elderberry.jpg' },
  ];

  const filteredItems = filterItems(originalItems);

  return (
    <div>
      <input
        type="text"
        placeholder="Filter items..."
        value={filter}
        onChange={handleFilterChange}
      />
      <ul id="filteredItems">
        {filteredItems.map((item) => (
          <li key={item.id}>
            <img src={item.imageUrl} alt={item.text} />
            {item.text}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilterwithImage;
